const axios = require("axios")

async function getTournament() {
    return new Promise(
        async function (resolve, reject) {
            try {
                const data = await axios.get(`${process.env.API_URL}/tournament/lobby`);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        }
    );
}

async function affiliateLinkClickLocal(uid) {
    return new Promise(
        async function (resolve, reject) {
            try {
                const data = await axios.get(`${process.env.AFFILIATE_PANEL_CLICK_URL}/link/${uid}`);
                resolve(data);
            } catch (e) {
                reject(e);
            }
        }
    );
}

export const ApiService = {
    getTournament,
    affiliateLinkClickLocal
}